module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset class="salesforce-commerce-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".salesforce-commerce-properties-accordion">\n        Product Widget\n    </legend>\n    <div class="salesforce-commerce-properties-accordion collapse collapse-target">\n        <div class="connect">\n            <a href="#integrations-salesforce-commerce" class="btn btn-small btn-grey">Connect with SFCC Account</a>\n        </div>\n\n        <div class="search-products">\n            ';
 if (sites.length === 1) { ;
__p += '\n                <label>Selected site: <b class="site">' +
__e( sites[0].get("siteId")) +
'</b> </label>\n                <input class="sites hidden" value="' +
__e( sites[0].id) +
'"/>\n            ';
 } else if (sites.length > 1) { ;
__p += '\n                Select a site:\n                <select class="sites form-control">\n                    <option value="">Select site</option>\n                    ';
 _.each(sites, function (site) { ;
__p += '\n                    <option value="' +
__e( site.id ) +
'">' +
__e( site.get("siteId") ) +
'</option>\n                ';
 }) ;
__p += '\n                </select>\n            ';
 } ;
__p += '\n            <input class="search header" type="search" placeholder="Search">\n\n            <small class="connection-error error"></small>\n            <div class="salesforce-commerce-results"></div>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceWidgetPropertiesView.tpl
// module id = 2062
// module chunks = 0